import {
  Container,
  Row,
  Col,
  Button,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import IconCard from "../../Components/IconCard";
import styles from "../../styles/home.module.scss";
import keycloakService from "../../modules";
import { ReactSVG } from "react-svg";
import AddInfo from "../User/AddInfo";
import EditInfo from "../User/EditInfo";
import React, { useEffect, useState } from "react";
import { GetUserCourses, GetUserCapCourses, fetchAppLinksData } from "../../axios/apis/Courses";
import { GetUserData ,GetUserkycInitiate ,GetUserkycCallback, GetUserkycReInitiate } from "../../axios/apis/Users";
import applicationLinks from '../../modules/applicationLinks';
import mergeWithDynamic from "../../utils/mergeCardData";
import ConsentBox from "../User/Consent";
import { useLocation , useNavigate } from "react-router-dom";
import { AppContext } from '../../contexts/AppContext'
import PermissionConsentBox from "../User/PermissionConsent";
import WithoutDigilockerConsent from "../User/WithoutDigilockerConsent";
import ReAadharAuthenticationModal from "../User/ReAadharAuthenticationModal"
import ReConsentBox from "../User/ReConsent";

export default function Home() {
  const [courseData, setCourseData] = useState([]);
  const [capCourseData, setCapCourseData] = useState([]);
  const [userData, setUserData] = useState([]);
  const [isEditModalVisible, setEditModalVisibility] = useState(false);
  const [cardData, setCardData] = useState([]);
  const [showConsent , setShowConsent] = useState(false)
  const [showProfile , setShowProfile] = useState(false)
  const [kycUrl , setKycUrl] = useState('')
  const [callApi , setCallApi] = useState(false)
  const [showPermissionBox , setShowPermissionBox] = useState(false)
  const [ showWithoutDigilocker ,setShowWithoutDigilocker] = useState(false)
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const { setLoader} = React.useContext(AppContext);
  const [showReAadharModal, setShowReAadharModal] = useState(false)
  const [showReConsent , setShowReConsent] = useState(false)
  const navigate = useNavigate();
  useEffect(() => {
    if (params.get("source") === "surepass") {
      setLoader(true)
      GetUserkycCallback()
        .then((result) => {
          setShowProfile(true)
          setCallApi(true)
          setLoader(false)
        })
        .catch((error) => {
          if(error.status == 400 && error.data.status == "false"){
              setShowPermissionBox(true)
          }else{
              navigate('/')
              window.location.reload();
          }
          setLoader(false)
        })
    } else {
      setLoader(true)
      GetUserkycInitiate()
        .then((result) => {
          if (result.status == "false") {
            setShowConsent(true)
            setKycUrl(result.url)
          } else {
             setCallApi(true)
            if(result?.userVerify == true){
               setShowConsent(false)
               if(!result?.apaarStatus){
                  setShowProfile(true)
               }
               GetUserData()
                .then((result) => {
                  setUserData(result);
                  if( result?.digilockerCount < 1 && result?.aadharReverificationConsent === false){
                    setShowReAadharModal(true)
                  }
                })
                .catch(error => {
                  console.log(error)
                })
            }else{
              setShowConsent(false)
              setShowProfile(true)
            }

          }
          setLoader(false)
        }).catch((error) => {
          setLoader(false)
          console.log(error);
        })
    }

  }, []);

  useEffect(()=>{
    if(callApi){
         GetUserCourses()
      .then((result) => {
        setCourseData(result);
      })
      .catch((error) => {
        // console.log(error);
      });
    
    GetUserCapCourses()
      .then((result) => {
        setCapCourseData(result);
      })
      .catch((error) => {
        console.log(error);
      });


    fetchAppLinksData()
      .then((dynamicData) => {
        const mergedData = mergeWithDynamic(applicationLinks, dynamicData);
        setCardData(mergedData);
      })
      .catch((error) => {
        console.error("Error fetching AppLinks data:", error);
        setCardData(applicationLinks);
      });
    }
  },[callApi])

  const handleButtonClick = () => {
    GetUserData()
      .then((result) => {
        setUserData(result);
        setEditModalVisibility(true);
      })
      .catch((error) => {
        if (error.status === 404) {
        }
      });
  };
  const handleCloseModal = () => {
    setEditModalVisibility(false);
  };

  const handleReAuthenticate = ()=> {
    setLoader(true)  
    GetUserkycReInitiate()
      .then((result) => {
        if (result.status == "false") {
          setShowReConsent(true)
          setKycUrl(result.url)
        }
        setLoader(false)
      }).catch((error) => {
        setLoader(false)
        console.log(error);
      })
  }

  return (
    <>
      <section className="py-5 py-md-6 py-lg-8 py-xl-10">
        <Container>
          <div className="d-flex align-items-center justify-content-end gap-2 mb-4 mb-md-5">
            <span className="text-primary fw-light fs-6">
              Hi,{" "}
              <strong className="fw-semibold">
                {userData?.candidateName || "User"}
              </strong>{" "}
            </span>

            {/* <OverlayTrigger overlay={<Tooltip>Edit profile</Tooltip>}>
              <Button
                type="button"
                variant="primary"
                className="cet_auth_btn"
                onClick={handleButtonClick}
              >
                <ReactSVG
                  src={`${process.env.PUBLIC_URL}/assets/images/icons/edit_profile.svg`}
                />
              </Button>
            </OverlayTrigger> */}

            <OverlayTrigger overlay={<Tooltip>Sign out</Tooltip>}>
              <Button
                onClick={() => keycloakService.doLogout()}
                type="button"
                variant="primary"
                className="cet_auth_btn"
              >
                <ReactSVG
                  src={`${process.env.PUBLIC_URL}/assets/images/icons/logout.svg`}
                />
              </Button>
            </OverlayTrigger>
          </div>
          <Row className="row-gap-6">
            <Col xs={12} lg={5}>
              <div
                className={`position-relative mx-auto mx-lg-0 ${styles.cet_about_image}`}
              >
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/about_image.jpg`}
                  alt="About"
                />
              </div>
            </Col>
            <Col xs={12} lg={7}>
              <Row className="justify-content-center row-gap-3 row-gap-md-4">
                {cardData?.map((item, index) => (
                  <Col xs={12} md={6} key={index}>
                    <IconCard cardData={item} course={courseData} capCourse={capCourseData} onUserDataChange={setUserData} />
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </Container>
        {showProfile && <AddInfo setUserData={setUserData}></AddInfo>}
        {showConsent && <ConsentBox showConsent={showConsent} kycUrl={kycUrl} setShowConsent={setShowConsent} setShowWithoutDigilocker={setShowWithoutDigilocker} />}
        {showWithoutDigilocker && <WithoutDigilockerConsent setShowWithoutDigilocker={setShowWithoutDigilocker} showWithoutDigilocker={showWithoutDigilocker} showProfile={showProfile} setShowProfile={setShowProfile} /> }
        {showPermissionBox && <PermissionConsentBox showPermissionBox={showPermissionBox} setShowPermissionBox={setShowPermissionBox} />}
        {showReAadharModal && <ReAadharAuthenticationModal
        show={showReAadharModal}
        onHide={() => {
          setShowReAadharModal(false)
        }}
        userData={userData}
        onReAuthenticate={() => {
          setShowReAadharModal(false)
          handleReAuthenticate()
        }}
      />}
      {showReConsent && <ReConsentBox showConsent={showReConsent} kycUrl={kycUrl} setShowConsent={setShowReConsent} />}
      
        {/* {isEditModalVisible && (
          <EditInfo
            userData={userData}
            showEditModal={isEditModalVisible}
            onHide={handleCloseModal}
          ></EditInfo>
        )} */}
      </section>
    </>
  );
}
